<script setup lang="ts">
import { RouterView, useRouter } from "vue-router";
import Header from "../views/Header/Header.vue";
import Menu from "../views/Menu/Menu.vue";
import signalRManager from '../helper/signalRManager';
import { onMounted, watch, ref } from "vue";
import { useUsersStore } from "../store/users.store";
import { initializeDeviceStores } from "../helper/storeLoader";
import { routeViewKey } from "../helper/routeViewKey";

const router = useRouter();
const store = useUsersStore();

// Indicateur de chargement pendant les transitions de route
const isNavigating = ref(false);
router.beforeEach(() => { isNavigating.value = true; });
router.afterEach(() => { isNavigating.value = false; });

// SIGNALR
onMounted(async () => {
	// store.loadUser() déjà appelé par storeLoader (Phase 2) avant le montage de l'app.
	// Le rappeler ici changerait la référence de currentCenter et déclencherait à tort
	// les watchers des pages (ex: SuiviFabrication) → double chargement.
	await initializeDeviceStores();

	if (store.isConnect) {
		await startSignalR();
	}
});

const startSignalR = async () => {
	if (!signalRManager.isInitialize) {
		// Initialization du client
		signalRManager.initialize(store.currentUser.email.toString());
	}

	if (!signalRManager.isConnected()) await signalRManager.start();
}

const stopSignalR = async () => {
	await signalRManager.dispose();
}

watch(() => store.isConnect, async (newValue) => {
	if (newValue) {
		startSignalR();
	} else {
		await stopSignalR();
	}
})
</script>

<template>
	<div class="main">
		<Menu />
		<div class="main-container">
			<Header />
			<div>
				<div class="main-container__content" v-loading="isNavigating">
					<RouterView v-slot="{ Component, route }">
						<component :is="Component" :key="routeViewKey(route)" />
					</RouterView>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.main {
	display: flex;
	height: 100vh;

	&-container {
		width: 100%;
		display: grid;
		grid-template-rows: auto 1fr;
		grid-auto-rows: auto;
		z-index: 2;

		&__content {
			overflow-y: auto;
			height: calc(100vh - 72px);
		}
	}
}

.main {
	::-webkit-scrollbar {
		width: 10px;
	}
}

::-webkit-scrollbar-track {
	background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
	background: #888;
}

::-webkit-scrollbar-thumb:hover {
	background: #555;
}

.scale-enter-active,
.scale-leave-active {
	transition: all 0.2s ease;
}

.scale-enter-from,
.scale-leave-to {
	opacity: 0;
	transform: scale(0.9);
}
</style>
